var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhnMessageOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 2592 2880",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6d920}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m132.9 979.69.55.38 152.39 105.24V598.88h2008.32v480.69l153.27-103.87.51-.35c20.78-13.93 21.76-44 1.18-58.19l-70.47-48.67V556.63a42.25 42.25 0 0 0-42.24-42.25H1866l-501.2-346.15a111.32 111.32 0 0 0-125.83-.49L727.4 514.38H243.59a42.25 42.25 0 0 0-42.24 42.25v314.25l-69.12 46.85c-22.04 14.94-21.32 46.95.67 61.96Z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2486.93 1034-1147.15 777.46a112.64 112.64 0 0 1-127.21-.55L93.44 1038c-33.7-23.28-79.67.84-79.67 41.8v1326.9a50.8 50.8 0 0 0 50.8 50.8h2450.86a50.8 50.8 0 0 0 50.8-50.8V1076c0-40.71-45.57-64.88-79.3-42Z",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhnMessageOpen);
export default __webpack_public_path__ + "static/media/phnMessageOpen.290fe8ef67cb1ee3897c90f71b8eced4.svg";
export { ForwardRef as ReactComponent };